// @flow

import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import { type FormikProps } from 'formik';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Form } from '../../components';
import { RequiredFieldMessage } from '../../components/Form';

import { login } from '../../ducks/auth';

import { navigate } from '../../lib/helpers';
import type { Credentials, FormErrors } from '../../lib/types';

type Props = {
  submit: Function,
  values: Credentials,
  handleChange: Function,
  handleBlur: Function,
  errors: Credentials,
  touched: Credentials,
  handleSubmit: Function,
  login: Function
};

class LoginForm extends Component<Props> {
  render() {
    return (
      <Form
        disableRequiredMessage
        validate={(values: Credentials) => {
          let errors: FormErrors<Credentials> = {};
          if (!values.userName) {
            errors.userName = new RequiredFieldMessage(
              'Обязательно для заполнения'
            );
          }
          if (!values.password) {
            errors.password = new RequiredFieldMessage(
              'Обязательно для заполнения'
            );
          }

          return errors;
        }}
        onSubmit={async (values: Credentials, { setErrors }) => {
          try {
            await this.props.login(values);
            await navigate('/');
          } catch (err) {
            setErrors({
              userName: null,
              password: 'Неверные логин или пароль'
            });
          }
        }}
      >
        {(FormField, formikProps: FormikProps) => {
          const { handleSubmit, isSubmitting } = formikProps;
          return (
            <StyledForm onSubmit={handleSubmit}>
              <Wrapper>
                <FormField label="Логин" name="userName">
                  {field => (
                    <Input
                      {...field}
                      placeholder="Введите логин"
                      size="large"
                    />
                  )}
                </FormField>
                <FormField label="Пароль" name="password">
                  {field => (
                    <Input
                      {...field}
                      placeholder="Введите пароль"
                      size="large"
                      type="password"
                    />
                  )}
                </FormField>
                <Button
                  disabled={isSubmitting}
                  loading={isSubmitting}
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  data-cy="login"
                  style={{ marginTop: 10 }}
                >
                  Войти
                </Button>
              </Wrapper>
            </StyledForm>
          );
        }}
      </Form>
    );
  }
}

export default connect(null, {
  login
})(LoginForm);

const StyledForm = styled.form`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
`;

const Wrapper = styled.div`
  width: 100%;
`;
